<template>
    <div class="container">
        <div v-if="loading">
            <!-- You could show a spinner or some placeholder here -->
        </div>
        <div v-else>
            <div v-if="realestate">
                <div role="button" class="small" @click="goBack()">
                    <i class="fa-solid fa-chevron-left m-2 mt-3"></i>{{ $t('common.back') }}
                </div>
                <h3 class="my-3">{{ realestate.name }}</h3>

                <div class="accordion shadow mt-3" id="accordionLocation">
                    <div class="accordion-item border-0">
                        <h2 class="accordion-header">
                            <button :class="{ 'text-body-tertiary': !realestate.address && !realestate.coordinates }" class="accordion-button collapsed fs-6 fw-bolder" type="button"
                                data-bs-toggle="collapse" data-bs-target="#collapseLocation" aria-expanded="false"
                                aria-controls="collapseLocation">
                                {{ $t('taskDetail.location') }}
                            </button>
                        </h2>
                        <div id="collapseLocation" class="accordion-collapse collapse"
                            data-bs-parent="#accordionLocation">
                            <div class="accordion-body text-multiline">
                                <div v-if="realestate.address">
                                    <div class="small my-3">{{ $t('taskDetail.address') }}: {{ realestate.address }}</div>
                                    <div class="row">
                                        <div class="col-auto">
                                            <a :href="googleMapsUrl" :target="mapTarget" rel="noopener"
                                                class="btn btn-primary btn-sm w-100">
                                                Google Maps
                                            </a>
                                        </div>
                                        <div class="col-auto">
                                            <a :href="wazeUrl" :target="mapTarget" rel="noopener"
                                                class="btn btn-primary btn-sm w-100">
                                                Waze
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="realestate.coordinates">
                                    <div class="small my-3">{{ $t('taskDetail.coordinates') }}: {{ realestate.coordinates }}</div>
                                    <div class="row">
                                        <div class="col-auto">
                                            <a :href="googleMapsUrlCoordinates" :target="mapTarget" rel="noopener"
                                                class="btn btn-primary btn-sm w-100">
                                                Google Maps
                                            </a>
                                        </div>
                                        <div class="col-auto">
                                            <a :href="wazeUrlCoordinates" :target="mapTarget" rel="noopener"
                                                class="btn btn-primary btn-sm w-100">
                                                Waze
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="!realestate.address && !realestate.coordinates" class="small fst-italic">
                                    {{ $t('taskDetail.noLocation') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="accordion shadow mt-3" id="accordionProjects2">
                    <!-- Accordion for type_id = 0 and user -->
                    <div class="accordion-item border-0">
                        <h2 class="accordion-header">
                            <button :class="{ 'text-body-tertiary': projectsType2.length == 0 }" class="accordion-button collapsed fs-6 fw-bolder" type="button"
                                data-bs-toggle="collapse" data-bs-target="#collapseType2" aria-expanded="false"
                                aria-controls="collapseType2">
                                {{ $t('browse.myBusinessLineCards') }}
                            </button>
                        </h2>
                        <div id="collapseType2" class="accordion-collapse collapse" data-bs-parent="#accordionProjects2">
                            <div class="accordion-body">
                                <ul class="list-group list-group-flush" v-if="projectsType2.length > 0">
                                    <router-link v-for="project in projectsType2" :key="project.id"
                                        :to="`/projects/${project.id}`" class="list-group-item list-group-item-action">
                                        {{ project.name }}
                                    </router-link>
                                </ul>
                                <div v-else class="fst-italic small">{{ $t('browse.noProjectCards') }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="accordion shadow mt-3" id="accordionProjects0">
                    <!-- Accordion for type_id = 0 -->
                    <div class="accordion-item border-0">
                        <h2 class="accordion-header">
                            <button :class="{ 'text-body-tertiary': projectsType0.length == 0 }" class="accordion-button collapsed fs-6 fw-bolder" type="button"
                                data-bs-toggle="collapse" data-bs-target="#collapseType0" aria-expanded="false"
                                aria-controls="collapseType0">
                                {{ $t('browse.projectCards') }}
                            </button>
                        </h2>
                        <div id="collapseType0" class="accordion-collapse collapse" data-bs-parent="#accordionProjects0">
                            <div class="accordion-body">
                                <ul class="list-group list-group-flush" v-if="projectsType0.length > 0">
                                    <router-link v-for="project in projectsType0" :key="project.id"
                                        :to="`/projects/${project.id}`" class="list-group-item list-group-item-action">
                                        {{ project.name }}
                                    </router-link>
                                </ul>
                                <div v-else class="fst-italic small">{{ $t('browse.noProjectCards') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="accordion shadow mt-3" id="accordionProjects1">
                    <!-- Accordion for type_id = 1 -->
                    <div class="accordion-item border-0">
                        <h2 class="accordion-header">
                            <button :class="{ 'text-body-tertiary': projectsType1.length == 0 }" class="accordion-button collapsed fs-6 fw-bolder" type="button"
                                data-bs-toggle="collapse" data-bs-target="#collapseType1" aria-expanded="false"
                                aria-controls="collapseType1">
                                {{ $t('browse.installationCards') }}
                            </button>
                        </h2>
                        <div id="collapseType1" class="accordion-collapse collapse" data-bs-parent="#accordionProjects1">
                            <div class="accordion-body">
                                <ul class="list-group list-group-flush" v-if="projectsType1.length > 0">
                                    <router-link v-for="project in projectsType1" :key="project.id"
                                        :to="`/projects/${project.id}`" class="list-group-item list-group-item-action">
                                        {{ project.name }}
                                    </router-link>
                                </ul>
                                <div v-else class="fst-italic small">{{ $t('browse.noInstallationCards') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3 g-2 justify-content-center">
                    <div class="col-auto">
                        <router-link :to="{ name: 'RealestateTasks', params: { realestateId: realestate.id }}">
                            <button class="btn btn-primary">{{ $t('browse.viewTasks') }}</button>
                        </router-link>
                    </div>
                    <div class="col-auto">
                        <router-link :to="{ name: 'RealestateMaintenanceLog', params: { realestateId: realestate.id }}">
                            <button class="btn btn-primary">{{ $t('maintenanceLog.title') }}</button>
                        </router-link>
                    </div>
                </div>
            </div>
            <NotFound v-else :item="$t('browse.realestateItem')" />
        </div>
    </div>
</template>

<script>
import axios from '@/services/axios';
import { setDocumentTitle } from '@/composables/usePageTitle';
import {
    googleMapsAddressUrl, googleMapsCoordinatesUrl,
    wazeAddressUrl, wazeCoordinatesUrl, mapLinkTarget,
} from '@/utils/mapLinks';
import NotFound from '@/components/NotFound.vue';

export default {
    data() {
        return {
            realestate: null,
            loading: true
        };
    },
    components: {
        NotFound
    },
    computed: {
        // Projects with type_id = 0
        projectsType0() {
            if (!this.realestate) return [];
            return this.realestate.projects.filter(proj => proj.type_id == 0 && !proj.user_profile_group);
        },
        // Projects with type_id = 1
        projectsType1() {
            if (!this.realestate) return [];
            return this.realestate.projects.filter(proj => proj.type_id == 1);
        },
        projectsType2() {
            if (!this.realestate) return [];
            return this.realestate.projects.filter(proj => proj.type_id == 0 && proj.user_profile_group);
        },
        googleMapsUrl() {
            return googleMapsAddressUrl(this.realestate.address);
        },
        wazeUrl() {
            return wazeAddressUrl(this.realestate.address);
        },
        googleMapsUrlCoordinates() {
            return googleMapsCoordinatesUrl(this.realestate.coordinates);
        },
        wazeUrlCoordinates() {
            return wazeCoordinatesUrl(this.realestate.coordinates);
        },
        mapTarget() {
            return mapLinkTarget();
        },
    },
    methods: {
        async fetchRealestate() {
            try {
                const realestateId = this.$route.params.realestateId;
                const response = await axios.get(`/realestates/${realestateId}`);
                this.realestate = response.data.data;
                setDocumentTitle(this.realestate?.name);
            } catch (error) {
                console.error('Error fetching realestate details:', error);
                // Optionally, handle the error (e.g., set an error message, redirect, etc.)
            } finally {
                this.loading = false;
            }
        },
        goBack() {
            if (this.$route.meta.internalNavigation && window.history.length > 2) {
                this.$router.go(-1);
            } else {
                this.$router.push('/');
            }
        },
    },
    mounted() {
        this.fetchRealestate();
    }
};
</script>